// @flow

import React from 'react';
import PropTypes from 'prop-types';
import ProjectContentDescription from '../ContentDescription';
import Tooltip from '../../../../../Resources/Common/Tooltip';

export default function Concept(props) {
  const { proposalUid, blocked, hasRights } = props;
  return (
    <ProjectContentDescription
      title="Le concept"
      tooltip={Tooltip.ProjectOfferConcept.description}
      proposalUid={proposalUid}
      blocked={blocked}
      hasRights={hasRights}
    />
  );
}

Concept.propTypes = {
  hasRights: PropTypes.bool.isRequired,
  blocked: PropTypes.bool.isRequired,
  proposalUid: PropTypes.string
};

Concept.defaultProps = {
  proposalUid: undefined
};
